export default function isFalsy(value: unknown): boolean {
  return (
    value === undefined || value === '' || value === null || value === false
  )
}
